export var createData: any = {
};

export function clearData(): void {
    createData = {};
}
